






import Vue from 'vue';

export default Vue.extend({
    name: 'Icon',
    props: {
        path: String,
        colour: {
            type: String,
            default: '#000000',
        },
        width: {
            type: Number,
            default: 24,
        },
        height: {
            type: Object as () => number | undefined,
            default: undefined,
        },
    },
    computed: {
        calcHeight(): number {
            if (this.height === undefined) {
                return this.width;
            } else {
                return this.height;
            }
        },
    },
});
